<template>
  <v-layout>
    <v-flex>
      <v-dialog v-model="show" max-width="1000px">
        <v-carousel :cycle="false" :height="550" v-model="currentItem">
            <v-carousel-item v-for="item in attachments" :key="item.asset.id">
              <v-hover>
                <v-card slot-scope="{ hover }" class="mx-auto" color="black" height="550">
                  <v-btn flat icon :href="item.asset.url" target="_blank" class="text-xs-right open-in-new-button">
                    <v-icon small color="white">open_in_new</v-icon>
                  </v-btn>
                  <v-layout align-center justify-center fill-height>
                    <v-flex><v-img :src="item.asset.url" contain max-height="550"></v-img></v-flex>
                  </v-layout>
                  <v-expand-transition>
                    <div v-if="hover" class="transition-fast-in-fast-out grey darken-2 v-card--reveal white--text pa-3"
                         :style="`height: ${getHoverHeight(item)}%;`">
                      <strong>Descripción: </strong>
                      <span>{{ item.asset.description || '-' }}</span>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-hover>
            </v-carousel-item>
        </v-carousel>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
const MIN_HOVER_HEIGHT = 29
const LINE_HEIGHT = 7
const MAX_LENGTH_PER_LINE = 150

export default {
  props: {
    attachments: Array
  },

  data () {
    return {
      show: false,
      currentItem: 0
    }
  },

  methods: {
    showDialog () {
      this.show = true
    },
    showDialogIndex (index) {
      this.currentItem = index
      this.showDialog()
    },
    getHoverHeight (item) {
      let length = (item.asset.description) ? item.asset.description.length : 0
      return (length / MAX_LENGTH_PER_LINE) * LINE_HEIGHT + MIN_HOVER_HEIGHT
    }
  }
}
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .6;
  position: absolute;
  width: 100%;
}
.open-in-new-button {
  position: absolute;
  text-shadow: 0 0 2px #000;
  z-index: 1;
}
</style>
